export default __webpack_public_path__ + "static/media/announcement_4.360f8552.png";